import { Container } from '@mui/material';
import { Taxonomy } from '../sections/Taxonomy';
import Metatags from '../components/MetaTags/MetaTags';

function TaxonomyBuilderPage() {
  return (
    <>
      <Metatags metaTagName="Taxonomy Builder | ISV Insights" />
      <Container maxWidth="xl">
        <Taxonomy />
      </Container>
    </>
  );
}

export default TaxonomyBuilderPage;
